// Display order for network groups/schools: A-Z by name, case- and accent-insensitive, numbers
// natural ("School 2" before "School 10"), nameless last. Returns a copy; callers keep API order.

const groupName = (group: any): string => (group?.group_name || group?.name || '').trim();

export function sortGroupsAlphabetically<T>(groups: T[]): T[] {
  return [...(groups || [])].sort((a, b) => {
    const nameA = groupName(a);
    const nameB = groupName(b);
    if (!nameA || !nameB) return nameA ? -1 : nameB ? 1 : 0;
    return nameA.localeCompare(nameB, undefined, { sensitivity: 'base', numeric: true });
  });
}
